import { Provider } from 'react-redux';
import { store } from './store';
import { AppRouter } from './router';
import AuthInitializer from './components/AuthInitializer';
import './App.css';

function App() {
    return (
        <Provider store={store}>
            <AuthInitializer>
                <AppRouter />
            </AuthInitializer>
        </Provider>
    );
}

export default App;
